import type { ReactNode } from 'react'
import { motion, useReducedMotion } from 'framer-motion'

// One short entrance per block. Reduced-motion users get the content with no movement.
export default function Reveal({ children, delay = 0, className }: { children: ReactNode; delay?: number; className?: string }) {
  const reduce = useReducedMotion()
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y: 8 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.16, delay, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  )
}
